import { Controller } from "react-hook-form";
import { Flex, Text } from "styles/utility-components";

import { AiChatInputExtension } from "components/ai_chat/inputExtension";
import Checkbox from "components/ui/checkbox/Checkbox";

function isBuyerQaResource(resourceType: string) {
  return resourceType === "BUYER_QA";
}

export const buyerQaInputExtension: AiChatInputExtension = {
  getDefaultValues: ({ resourceType }) => {
    if (!isBuyerQaResource(resourceType)) {
      return {};
    }

    return {
      sources: {
        notices: true,
        documents: true,
      },
    };
  },
  refineQuestionForm: (values, ctx, { resourceType }) => {
    if (!isBuyerQaResource(resourceType)) {
      return;
    }

    if (values.sources?.notices === false && values.sources?.documents === false) {
      ctx.addIssue({
        code: "custom",
        message: "Select at least one search source",
        path: ["sources", "notices"],
      });
    }
  },
  renderControls: ({ control, values, resourceType }) => {
    if (!isBuyerQaResource(resourceType)) {
      return null;
    }

    const hasSourceSelectionError =
      values.sources?.notices === false && values.sources?.documents === false;

    return (
      <Flex column gap={6}>
        <Flex gap={16} alignItems="center" flexWrap="wrap">
          <Controller
            name="sources.notices"
            control={control}
            render={({ field }) => (
              <Flex gap={8} alignItems="center">
                <Checkbox
                  id="include-notices"
                  checked={field.value ?? true}
                  onCheckedChange={(checked) => field.onChange(checked === true)}
                />
                <label htmlFor="include-notices">Tender notices</label>
              </Flex>
            )}
          />
          <Controller
            name="sources.documents"
            control={control}
            render={({ field }) => (
              <Flex gap={8} alignItems="center">
                <Checkbox
                  id="include-documents"
                  checked={field.value ?? true}
                  onCheckedChange={(checked) => field.onChange(checked === true)}
                />
                <label htmlFor="include-documents">Buyer documents</label>
              </Flex>
            )}
          />
        </Flex>
        {hasSourceSelectionError && (
          <Text color="sysTextError" description>
            Select at least one search source
          </Text>
        )}
      </Flex>
    );
  },
  mapRequest: ({ values, resourceType }) => {
    if (!isBuyerQaResource(resourceType)) {
      return {};
    }

    return {
      sources: {
        notices: values.sources?.notices,
        documents: values.sources?.documents,
      },
    };
  },
  isSubmitDisabled: ({ values, resourceType }) => {
    if (!isBuyerQaResource(resourceType)) {
      return false;
    }

    return values.sources?.notices === false && values.sources?.documents === false;
  },
};
